import script from "./OListaDeProfissionais.vue?vue&type=script&lang=ts&setup=true"
export * from "./OListaDeProfissionais.vue?vue&type=script&lang=ts&setup=true"

import "./OListaDeProfissionais.vue?vue&type=style&index=0&id=a6a2896a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a6a2896a"]])

export default __exports__